import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import ScrollableView from '$app-web/components/scrollable-view';
import { URLsManager } from '$app-web/utils';

import useStyles from './styles';

const AuthContentWrapper = (props) => {
    const { children } = props;

    const classes = useStyles();

    const matchedRoutes = {
        signUp: Boolean(useRouteMatch(URLsManager.to('dashboard:auth:SIGN_UP'))),
    };

    return (
        <ScrollableView hideX>
            <Grid container direction="column" wrap="nowrap" className={classes.contentWrapper}>
                {/*
                    This method used to fix justify=center issue.
                    https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
                */}
                {!matchedRoutes.signUp && <div className={classes.contentCenterWrapper}>{children}</div>}
                {matchedRoutes.signUp && children}
            </Grid>
        </ScrollableView>
    );
};

AuthContentWrapper.propTypes = {
    children: PropTypes.element.isRequired,
};

export default AuthContentWrapper;
